
import { registerBlockType } from '@quillforms/blocks';
import Element from './short-text';

registerBlockType('custom-short-text', {
  supports: {
		editable: true,
		required: true,
		attachment: true,
		description: true,
		placeholder: true,
		defaultValue: true,
		logic: true,
		theme: true
	},
	attributes: {
		minCharacters: {
			type: [ "boolean", "number" ],
			default: false
		},
		setMaxCharacters: {
			type: "boolean",
			default: false
		},
		maxCharacters: {
			type: "number",
			multipleOf: 1
		},
    focusOnMount: {
      type: 'boolean',
      default: false
    },
    nextOnEnter: {
      type: 'boolean',
      default: false
    },
    capitalize: {
      type: 'boolean',
      default: false
    },
    type: {
      type: ['password', 'text'],
      default: 'text'
    }
	},
	logicalOperators: [
		'is',
		'is_not',
		'starts_with',
		'contains',
		'ends_with',
		'not_contains'
	],

  display: (props) => <Element {...props} />
});

